import React, { useState } from "react";
import { addWeeksAndFormat, addWeeksDaysAndFormat } from "./dateUtils"
import ChildrenButton from "./ChildrenButton";
import DateLine from "./DateLine";
import NumberInput from "./NumberInput";

export default function Conges({ baseDate }) {
    const [children, setChildren] = React.useState(0);
    const [selectedButton, setSelectedButton] = React.useState(1);
    const [startDate, setStartDate] = React.useState(undefined)
    const [endDate, setEndDate] = React.useState(undefined)

    const handleNumberOfBabiesChange = (number) => {
        setSelectedButton(number);
    };

    React.useEffect(() => {
        if (children < 2 && selectedButton == 1) {
            const startDate = addWeeksAndFormat(baseDate, 33)
            setStartDate(startDate)
            const endDate = addWeeksDaysAndFormat(baseDate, 39, 69)
            setEndDate(endDate)
        } else if (children >= 2 && selectedButton == 1) {
            const startDate = addWeeksAndFormat(baseDate, 31)
            setStartDate(startDate)
            const endDate = addWeeksDaysAndFormat(baseDate, 46, 76)
            setEndDate(endDate)
        } else if (selectedButton == 2) {
            const startDate = addWeeksAndFormat(baseDate, 27)
            setStartDate(startDate)
            const endDate = addWeeksDaysAndFormat(baseDate, 50, 76)
            setEndDate(endDate)
        } else if (selectedButton == 3) {
            const startDate = addWeeksAndFormat(baseDate, 15)
            setStartDate(startDate)
            const endDate = addWeeksDaysAndFormat(baseDate, 50, 76)
            setEndDate(endDate)
        }
    }, [children, selectedButton, baseDate])

    return (
        <div className="">
            <div className="text-white flex gap-4 items-center">
                <p className="shrink-0 text-xs sm:text-sm">Nombre d'enfant(s) déjà né(s)</p>
                <div className="w-[100px]">
                    <NumberInput children={children} setChildren={setChildren} />
                </div>
            </div>
            <div className="text-white flex gap-4 items-center mt-3">
                <p className="shrink-0 text-xs sm:text-sm">Vous êtes enceinte</p>
            </div>
            <div className="flex gap-2 sm:gap-4 items-stretch mt-2">
                <label className="sr-only">Vous êtes enceinte</label>
                <ChildrenButton number={1} onClick={handleNumberOfBabiesChange} isSelected={selectedButton === 1} />
                <ChildrenButton number={2} onClick={handleNumberOfBabiesChange} isSelected={selectedButton === 2} />
                <ChildrenButton number={3} onClick={handleNumberOfBabiesChange} isSelected={selectedButton >= 3} />
            </div>
            <div className="mt-4">
                <DateLine
                    description="Début des congés"
                    date={startDate}
                />
                <DateLine
                    description="Fin des congés"
                    date={endDate}
                />
                <DateLine
                    description="Couverture totale de l'assurance maladie dès le"
                    date={addWeeksDaysAndFormat(baseDate, 21, 6)}
                />
            </div>
        </div>
    );
}
